import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { ComponentsComponent } from './components/components.component';
import { ContactoComponent } from './components/contacto/contacto.component';
import { PaquetesComponent } from './components/paquetes/paquetes.component';
import { AereoComponent } from './components/aereo/aereo.component';
import { PaqueteComponent } from './components/paquete/paquete.component';
import { TerminosycondicionesComponent } from './components/terminosycondiciones/terminosycondiciones.component';
import { GrupoComponent } from './components/grupo/grupo.component';
import { CotizacionComponent } from './components/cotizacion/cotizacion.component';

const routes: Routes =[
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: ComponentsComponent },
    { path: 'cotizacion/:id', component: CotizacionComponent},
    { path: "**", redirectTo: 'home', pathMatch: 'full' }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,{
      useHash: false
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
